const faturasRoutes = [
  // Boleto
  {
    path: '/boletos',
    name: 'boleto-list',
    component: () => import('@/views/boleto/BoletoDashboard.vue'),
    meta: {
      resource: 'Auth',
      action: 'read',
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Faturas', active: true },
      ],
    },
  },
  {
    path: '/boleto/view/:id',
    name: 'boleto-view',
    component: () => import('@/views/boleto/BoletoView.vue'),
    meta: {
      resource: 'Auth',
      action: 'read',
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Boletos', url: '/boleto/list' },
        { title: 'Visualizar', active: true },
      ],
    },
  },
]

export default faturasRoutes
